import axios from "axios";
import { API_BASE_URL } from "../ApiBaseUrl";
import authHeader from "../auth-header";

// ---------------------------------------------------------------
// Auth
// ---------------------------------------------------------------
const login = async (usernameOrEmail, password) => {
  const res = await axios.post(API_BASE_URL + "/auth/login", {
    username: usernameOrEmail,
    password,
  });

  const data = res.data;

  const userToStore = {
    accessToken: data?.token,
    id: data?.admin?.id,
    username: data?.admin?.username,
    fullName: data?.admin?.fullName,
    role: data?.admin?.role,
    adminYn: "Y",
  };

  localStorage.setItem("user", JSON.stringify(userToStore));
  localStorage.setItem("adminYn", "Y");

  axios.defaults.headers.common["Authorization"] = "Bearer " + userToStore.accessToken;
  window.dispatchEvent(new Event("nava-login"));

  return userToStore;
};

const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("adminYn");
  delete axios.defaults.headers.common["Authorization"];
  window.dispatchEvent(new Event("nava-logout"));
};

const getMe = () => {
  return axios.get(API_BASE_URL + "/auth/me", { headers: authHeader() });
};

// ---------------------------------------------------------------
// Counties
// ---------------------------------------------------------------
const getCounties = () => {
  return axios.get(API_BASE_URL + "/counties");
};

const addCounty = (name) => {
  return axios.post(API_BASE_URL + "/counties", { name }, { headers: authHeader() });
};

const deleteCounty = (countyId) => {
  return axios.delete(API_BASE_URL + "/counties/" + countyId, { headers: authHeader() });
};

// ---------------------------------------------------------------
// Properties
// ---------------------------------------------------------------
const getProperties = (params = {}) => {
  return axios.get(API_BASE_URL + "/properties", { params });
};

const getPropertyById = (propertyId) => {
  return axios.get(API_BASE_URL + "/properties/" + propertyId);
};

const importPropertyItem = (files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));
  return axios.post(API_BASE_URL + "/properties/import", formData, {
    headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
  });
};

const createProperty = (data) => {
  return axios.post(API_BASE_URL + "/properties", data, { headers: authHeader() });
};

const updateProperty = (propertyId, data) => {
  return axios.put(API_BASE_URL + "/properties/" + propertyId, data, { headers: authHeader() });
};

const deleteProperty = (propertyId) => {
  return axios.delete(API_BASE_URL + "/properties/" + propertyId, { headers: authHeader() });
};

// ---------------------------------------------------------------
// Property images
// ---------------------------------------------------------------
const uploadPropertyImage = (propertyId, file) => {
  const url = `${API_BASE_URL}/properties/${propertyId}/images`;
  const formData = new FormData();
  formData.append("image", file);
  return axios.post(url, formData, {
    headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
  });
};

const getPropertyImageUrl = (propertyId, fileName) => {
  return `${API_BASE_URL}/properties/${propertyId}/images/${fileName}`;
};

const deletePropertyImage = (propertyId, imageId) => {
  const url = `${API_BASE_URL}/properties/${propertyId}/images/${imageId}`;
  return axios.delete(url, { headers: authHeader() });
};

// ---------------------------------------------------------------
// Client messages
// ---------------------------------------------------------------
// data shape: { firstName, email, subject, message }
const postMessage = (data) => {
  return axios.post(API_BASE_URL + "/messages", data);
};

const getMessages = () => {
  return axios.get(API_BASE_URL + "/messages", { headers: authHeader() });
};

const markMessageRead = (messageId) => {
  return axios.patch(API_BASE_URL + "/messages/" + messageId + "/read", {}, { headers: authHeader() });
};

const deleteMessage = (messageId) => {
  return axios.delete(API_BASE_URL + "/messages/" + messageId, { headers: authHeader() });
};

export default {
  login,
  logout,
  getMe,
  getCounties,
  addCounty,
  deleteCounty,
  getProperties,
  getPropertyById,
  importPropertyItem,
  createProperty,
  updateProperty,
  deleteProperty,
  uploadPropertyImage,
  getPropertyImageUrl,
  deletePropertyImage,
  postMessage,
  getMessages,
  markMessageRead,
  deleteMessage,
};